"use strict";
var __webpack_require__ = {};
(()=>{
    __webpack_require__.d = (exports1, definition)=>{
        for(var key in definition)if (__webpack_require__.o(definition, key) && !__webpack_require__.o(exports1, key)) Object.defineProperty(exports1, key, {
            enumerable: true,
            get: definition[key]
        });
    };
})();
(()=>{
    __webpack_require__.o = (obj, prop)=>Object.prototype.hasOwnProperty.call(obj, prop);
})();
(()=>{
    __webpack_require__.r = (exports1)=>{
        if ('undefined' != typeof Symbol && Symbol.toStringTag) Object.defineProperty(exports1, Symbol.toStringTag, {
            value: 'Module'
        });
        Object.defineProperty(exports1, '__esModule', {
            value: true
        });
    };
})();
var __webpack_exports__ = {};
__webpack_require__.r(__webpack_exports__);
__webpack_require__.d(__webpack_exports__, {
    gatewayRequestConfigKey: ()=>gatewayRequestConfigKey,
    gatewayPlugin: ()=>gatewayPlugin,
    gatewayUnauthorizedHeader: ()=>gatewayUnauthorizedHeader
});
const index_js_namespaceObject = require("../../domain-id/index.js");
const external_gateway_index_js_namespaceObject = require("../../gateway/index.js");
const gateway_jwt_service_js_namespaceObject = require("../../gateway/gateway-jwt.service.js");
const query_config_js_namespaceObject = require("../../utils/query.config.js");
function isAbsoluteURL(url) {
    if (void 0 === url) return false;
    return /^([a-z][a-z\d+\-.]*:)?\/\//i.test(url);
}
const showLog = (0, query_config_js_namespaceObject.libHasQuery)('x-bcgw-log');
function combineURLs(baseURL, relativeURL) {
    return relativeURL ? `${baseURL.replace(/\/+$/, '')}/${relativeURL.replace(/^\/+/, '')}` : baseURL;
}
const isTrue = (value)=>true === value || 'true' === value;
const gatewayRequestConfigKey = Symbol('gatewayRequestConfig');
const gatewayUnauthorizedHeader = 'x-bcgw-unauthorized';
const gatewayPlugin = (param)=>{
    let { handleGatewayRequest, rewrittenDomainID, rewriteRules, getJwt: outerGetJwt } = param;
    return {
        request: [
            async (config)=>{
                var _config_pluginConfig, _config_pluginConfig1, _config_pluginConfig2;
                const logKey = Date.now();
                if (showLog) console.log('before gateway plugin', logKey, JSON.stringify(config));
                if (config.baseURL && !isAbsoluteURL(config.url)) {
                    config.url = combineURLs(config.baseURL, config.url);
                    config.baseURL = void 0;
                }
                const certainGatewayKey = null == (_config_pluginConfig = config.pluginConfig) ? void 0 : _config_pluginConfig.gatewayKey;
                const certainDomainID = null == (_config_pluginConfig1 = config.pluginConfig) ? void 0 : _config_pluginConfig1.domainID;
                const certainVRegion = null == (_config_pluginConfig2 = config.pluginConfig) ? void 0 : _config_pluginConfig2.vRegion;
                const innerHandleGatewayRequest = handleGatewayRequest || (0, external_gateway_index_js_namespaceObject.createHandleGatewayRequest)({
                    rewriteRules: rewriteRules || [],
                    rewrittenDomainID: rewrittenDomainID || [],
                    defaultDomainID: index_js_namespaceObject.currentDomainID,
                    defaultGatewayKey: 'undefined' != typeof window && window.defaultCloudGatewayKey
                });
                const requestConfig = await innerHandleGatewayRequest({
                    url: config.url,
                    certainDomainID,
                    certainGatewayKey,
                    certainVRegion
                });
                config.pluginConfig = config.pluginConfig || {};
                if (requestConfig) {
                    var _config_pluginConfig3, _config_pluginConfig4, _config_pluginConfig5;
                    config.pluginConfig[gatewayRequestConfigKey] = requestConfig;
                    config.url = requestConfig.url;
                    if (!(null == (_config_pluginConfig3 = config.pluginConfig) ? void 0 : _config_pluginConfig3.disableGatewayCredentials)) config.withCredentials = requestConfig.withCredentials;
                    if (!(null == (_config_pluginConfig4 = config.pluginConfig) ? void 0 : _config_pluginConfig4.disableGatewayJwt) && (requestConfig.withJwt || 'function' == typeof outerGetJwt)) {
                        var _config_pluginConfig6;
                        config.headers = config.headers || {};
                        if (!(null == (_config_pluginConfig6 = config.pluginConfig) ? void 0 : _config_pluginConfig6.respectGatewayJwtHeaderKeyCase)) {
                            delete config.headers['X-Jwt-Token'];
                            delete config.headers['X-JWT-TOKEN'];
                        }
                        config.headers['x-jwt-token'] = 'function' == typeof outerGetJwt ? await outerGetJwt(requestConfig.jwtUniqueKey) : await gateway_jwt_service_js_namespaceObject.gatewayJwtService.getService(requestConfig.jwtUniqueKey).then((service)=>service.getJwt());
                        config.pluginConfig.jwtDisabled = true;
                        config.pluginConfig.disableJwtPlugin = true;
                    }
                    if ((null == (_config_pluginConfig5 = config.pluginConfig) ? void 0 : _config_pluginConfig5.enableOperationsGatewayProxyMode) && requestConfig.withOGCommonPathMode) config.headers['x-og-common-path-mode'] = 'true';
                }
                if (showLog) console.log('after gateway plugin', logKey, JSON.stringify(config));
                return config;
            }
        ],
        response: [
            async (response)=>{
                var _config_pluginConfig, _response_headers;
                const config = null == response ? void 0 : response.config;
                const requestConfig = null == config ? void 0 : null == (_config_pluginConfig = config.pluginConfig) ? void 0 : _config_pluginConfig[gatewayRequestConfigKey];
                if (requestConfig && 401 === response.status && isTrue(null == (_response_headers = response.headers) ? void 0 : _response_headers[gatewayUnauthorizedHeader]) && 'function' != typeof outerGetJwt) await gateway_jwt_service_js_namespaceObject.gatewayJwtService.getService(requestConfig.jwtUniqueKey).then((service)=>service.redirectToLogin());
                return response;
            },
            async (error)=>{
                var _config_pluginConfig, _response_headers;
                const config = null == error ? void 0 : error.config;
                const response = null == error ? void 0 : error.response;
                const requestConfig = null == config ? void 0 : null == (_config_pluginConfig = config.pluginConfig) ? void 0 : _config_pluginConfig[gatewayRequestConfigKey];
                if (requestConfig && (null == response ? void 0 : response.status) === 401 && isTrue(null == response ? void 0 : null == (_response_headers = response.headers) ? void 0 : _response_headers[gatewayUnauthorizedHeader]) && 'function' != typeof outerGetJwt) await gateway_jwt_service_js_namespaceObject.gatewayJwtService.getService(requestConfig.jwtUniqueKey).then((service)=>service.redirectToLogin());
                return Promise.reject(error);
            }
        ]
    };
};
exports.gatewayPlugin = __webpack_exports__.gatewayPlugin;
exports.gatewayRequestConfigKey = __webpack_exports__.gatewayRequestConfigKey;
exports.gatewayUnauthorizedHeader = __webpack_exports__.gatewayUnauthorizedHeader;
for(var __webpack_i__ in __webpack_exports__)if (-1 === [
    "gatewayPlugin",
    "gatewayRequestConfigKey",
    "gatewayUnauthorizedHeader"
].indexOf(__webpack_i__)) exports[__webpack_i__] = __webpack_exports__[__webpack_i__];
Object.defineProperty(exports, '__esModule', {
    value: true
});
